/**
 * 轮播组件 biliSlider
 * 提供基本的轮播组件功能，在指定元素内生成整个轮播组件的dom结构。
 * (pc和移动端都可使用，移动端支持手指划动)
 *
 *
 * @author  zero (mengguanjie@bilibili.com)
 * @date    2016-6-28
 * @version 0.0.2
 *
 * @depend  必要依赖jQuery v1.7.2+或Zepto v1.1.6+
 */

;(function($){
    'use strict';
    //  参考自base.mobile的browser对象
    var browser = {
        version: (function() {
            var u = navigator.userAgent,
            app = navigator.appVersion;
            return { //移动终端信息
                mobile: (/AppleWebKit.*Mobile.*/i).test(u),
                //是否为移动终端
                ios: (/\(i[^;]+;( U;)? CPU.+Mac OS X/i).test(u),
                //ios终端
                android: (/Android/i).test(u) || (/Linux/i).test(u),
                //android终端或者uc浏览器
                windowsphone: (/Windows Phone/i).test(u),
                //Windows Phone
                iPhone: (/iPhone/i).test(u),
                //是否为iPhone或者QQHD浏览器
                iPad: (/iPad/i).test(u),
                //是否iPad
                webApp: !(/Safari/i).test(u),
                //是否web应该程序，没有头部与底部
            };
        })(),
        language: (navigator.browserLanguage || navigator.language).toLowerCase()
    };

    var methods = {
        init: function(options) {
            var sliderParams = {
                type: 'title',
                // 轮播dom的类型，提供title,thumbnail,gallery 3种
                moreLink: false,
                // 是否带 '更多' 按钮，只在default和title类型中可用
                data: [],
                // 数据源，需要规定格式为[ { title:'标题', link:'跳转地址', img:'大图src', small_image:'缩略图src'},...]
                timeout: 5000,
                // 自动轮播间隔，填0时不自动轮播
                mode: 'click',
                // 图标触发轮播事件的方式，有click和hover两种
                onInit: null,
                // 整个模块加载完毕后的回调函数 function(wrapper, data)
                onSlide: null,
                // 每次轮播换图后的回调函数 function(wrapper, index)
                onRender: null,
                // 轮播的每一个图片元素dom载入后回调 function(wrapper,data,index,item)
                onBarRender: null,
                // 按钮拦的每一个按钮元素dom载入后回调 function(barItem, data, index)

                fade: false, // 渐隐模式，待完善

                animTime: 600, // 动画完成时间

                transFunc: 'linear', // transition动画函数

                stepLength: 1, // 步长，每次轮播切换跨越的个数

                filter: null, // barItem 过滤掉指定的barItem

                loop: true,

                loadCss: false,
                // 是否需要用js加载一个额外的css文件，需要的话输入一个地址

                // 以下为影响dom结构的参数

                parent: $(this).eq(0),
                // 容器

                wrapper: $('<div class="slider-wrapper"><div class="slider-list-wrapper"><ul class="slider-ul"></ul></div><div class="s-bottom"></div></div>'),
                // 预先包裹容器，首先会往容器里面添加的dom结构

                item: '<li><a target="_blank"><img /></a></li>',
                // 轮播图片元素，循环添加到wrapper里面的第一个ul标签内

                barContainer: ".s-bottom",
                // 按钮拦的外部容器，填的是一个选择器字符串，元素需要先写到wrapper中

                bar: $('<ul class="slider-bar"></ul>'),
                // 底部按钮拦，会被添加到barContainer中的dom结构

                barItem: '<li></li>'
                // 按钮子元素，循环添加到bar容器内

                // renderCallback(wrapper, data, index) 轮播的每一个图片元素dom载入后回调
                // initCallback(wrapper, data) 整个轮播初始化完成后回调
                // barRenderCallback(barItem, data, index) 按钮拦的每一个按钮元素dom载入后回调
                // slideCallback(wrapper, index) 每次轮播换图后回调

            };


            // if (sliderParams.loadCss) {
            //     $('<link rel="stylesheet" type="text/css" href="'+ sliderParams.loadCss +'">').appendTo('head');
            // }

            var moreLink = options.moreLink ? ('<a class="more-topic" href="'+ options.moreLink +'" target="_blank">更多<i class="b-icon b-icon-arrow-r"></i></a>') : '';
            switch(options.type) {
                case 'title':
                    // 默认的模式 带标题 圆按钮
                    $.extend(sliderParams, {
                        wrapper:$('<div class="slider-wrapper"><div class="slider-list-wrapper"><ul class="slider-ul"></ul></div>' + moreLink + '<div class="s-bottom"><div class="title"></div></div></div>'),
                        renderCallback:function(wrapper,data,index){
                            var title = $('<span><a href="'+data.link+'" target="_blank">'+data.title+'</a></span>').appendTo($(".title",wrapper));
                            if(index==0){
                                title.show();
                            }
                            $('.slider-ul li',wrapper).width($(wrapper).width());

                            if (sliderParams.onRender && typeof sliderParams.onRender == 'function'){
                                sliderParams.onRender.call(this,wrapper,data,index);
                            }
                        },
                        slideCallback:function(wrapper,index){
                            $(".title span", wrapper).hide();
                            // var title = $(".title", wrapper).find("span:eq(" + index + ")").show();
                            var title = $(".title", wrapper).find("span").eq(index).show();
                            // if (!title.hasClass('animated')) {
                            //     title.addClass('animated').fadeIn(200,function (){
                            //         $(this).removeClass('animated');
                            //     });
                            // }
                        }
                    });
                    break;
                case 'thumbnail':
                    // 带标题和带缩略图
                    $.extend(sliderParams, {
                        wrapper: $('<div class="slider-wrapper ex ex-l"><div class="slider-list-wrapper"><ul class="slider-ul"></ul></div><div class="s-bottom-wrapper"><div class="s-bottom"><div class="title"></div></div></div></div>'),
                        initCallback: function(wrapper, data) {
                            $('.title', wrapper).appendTo(wrapper.find(".s-bottom"));
                            var current = $('<li class="current"></li>').appendTo(wrapper.find(".slider-bar"));
                            if (sliderParams.onInit && typeof sliderParams.onInit == 'function'){
                                sliderParams.onInit.call(this,wrapper,data);
                            }
                        },
                        barRenderCallback: function(barItem, data, index) {
                            // var link = $('<a href="' + data.link + '" target="_blank"></a>').appendTo(barItem);
                            var link = $('<a href="javascript:;"></a>').appendTo(barItem);
                            var img = $('<img src="' + data.small_image + '" alt="' + (data.title || '') + '" />').appendTo(link);
                            var mask = $('<div>').addClass('mask').appendTo(link);
                        },
                        renderCallback: function(wrapper, data, index) {
                            var title = $('<span><a href="' + data.link + '" title="' + data.title + '" target="_blank">' + data.title + '</a></span>').appendTo($(".title", wrapper));
                            $("[preview] img", wrapper).eq(index).attr('alt', data.title);
                            if (index == 0) {
                                title.show();
                            }
                            $('.slider-ul li',wrapper).width($(wrapper).width());
                            if (sliderParams.onRender && typeof sliderParams.onRender == 'function'){
                                sliderParams.onRender.call(this,wrapper,data,index);
                            }
                        },
                        slideCallback: function(wrapper, index) {
                            $(".title span", wrapper).hide();
                            var title = $(".title", wrapper).find("span").eq(index).show();
                            // if (!title.hasClass('animated')) {
                            //     title.addClass('animated').fadeIn(200,function (){
                            //         $(this).removeClass('animated');
                            //     });
                            // }

                            var bar = wrapper.find(".slider-bar");
                            if ($('.current', bar).length == 0) {
                                var current = $('<li class="current"></li>').appendTo(bar);
                            } else {
                                var current = $('.current', bar);
                            }
                            var barItem = bar.find('li[bar]').eq(index);
                            if(barItem.position()) {
                                var left = barItem.position().left  + parseInt(barItem.css("margin-left")) - parseInt(current.css("border-left-width"));
                                current.css("left", left);
                            }

                        }
                    });
                    break;
                case 'gallery':
                    $.extend(sliderParams, {
                        wrapper: $('<div class="slider-wrapper-gallery"><div class="slider-list-wrapper"><ul class="slider-ul"></ul></div><div class="s-bottom"></div></div>'),
                        // 预先包裹容器
                        item: '<li><img /></li>',
                        // 轮播图片元素
                        bar: $('<ul class="slider-bar"></ul>'),
                        // 底部按钮拦 ul
                        barContainer: ".s-bottom",
                        // 按钮拦的外部容器
                        barItem: '<li></li>',
                        // 按钮子元素
                        initCallback: function(wrapper, data) {
                            var sc = this,
                            slist = $('.slider-list-wrapper',wrapper),
                            sbottom = $('.s-bottom',wrapper),
                            botLi = $('.slider-bar li img',wrapper);

                            var next = $('<div class="slider-next"></div>').on('click',function () {
                                sc.next.call(sc);
                            }).appendTo(slist);
                            var prev = $('<div class="slider-prev"></div>').on('click',function () {
                                sc.prev.call(sc);
                            }).appendTo(slist);

                            var leftAr = $('<div class="left-arrow"><div class="arrow"></div></div>').on('click',function (){
                                sc.prev.call(sc);
                            }).appendTo(sbottom);
                            var rightAr = $('<div class="right-arrow"><div class="arrow"></div></div>').on('click',function (){
                                sc.next.call(sc);
                            }).appendTo(sbottom);

                            if (sliderParams.onInit && typeof sliderParams.onInit == 'function'){
                                sliderParams.onInit.call(this,wrapper,data);
                            }

                        },
                        barRenderCallback: function(barItem, data, index) {
                            // var link = $('<a href="' + data.link + '" target="_blank"></a>').appendTo(barItem);
                            var img = $('<img src="' + data.small_image + '" alt="' + (data.title || '') + '" />').appendTo(barItem);
                            // var mask = $('<div>').addClass('mask').appendTo(link);

                        },
                        renderCallback: function(wrapper, data, index) {
                            var wrapperWidth = $(wrapper).width(),
                                thisImg = $('.slider-ul img',wrapper).eq(index),
                                thisWidth = thisImg.width();
                            $('.slider-ul li',wrapper).width(wrapperWidth);
                            // if (data.link && data.link.length > 0) {
                            //     thisImg.wrap('<a target="_blank" href="'+ data.link +'"></a>');
                            // }
                            thisImg.on('load',function(){
                                if (wrapperWidth < $(this).width()){
                                    $(this).css('right',($(this).width() - wrapperWidth)/2 + 'px');
                                }
                            });
                            if (sliderParams.onRender && typeof sliderParams.onRender == 'function'){
                                sliderParams.onRender.call(this,wrapper,data,index);
                            }
                        },
                        slideCallback: function(wrapper, index) {
                            var sbar = $('.slider-bar',wrapper),
                            box = $('.slider-bar li',wrapper),
                            thisBox = box.eq(index),
                            boxWidth = box.width();

                            // sbar.css('left','-' + boxWidth * index + 'px');
                            if ( (thisBox.offset().left + boxWidth) > $('.s-bottom',wrapper).width()) {
                                sbar.css('left','-' + thisBox.position().left + 'px');
                            } else if (thisBox.offset().left < 0) {
                                sbar.css('left','-' + thisBox.position().left + 'px');
                            }
                        }
                    });
                    break;
                case 'showcase':
                    $.extend(sliderParams,{
                        wrapper: $('<div class="slider-showcase"><div class="slider-top"><ul class="slider-ul"></ul></div><div class="slider-bottom"></div></div>'),
                        // 预先包裹容器 就是整个要建立的dom结构！！
                        item: '<li><div class="slider-box"><img class="slider-img" /><p class="slider-p"></p></div></li>',
                        // 轮播图片元素 就是往wrapper的第一个ul元素里面放！
                        bar: $('<ul class="slider-bar"></ul>'),
                        // 底部按钮拦 就是往barContainer里面放的元素！
                        barContainer: ".slider-bottom",
                        // 按钮拦的外部容器  填一个选择器选择用来放bar的元素！要预先写在wrapper里面！
                        barItem: '<li></li>',
                        // 按钮子元素 就是往bar里面放的元素！

                        filter: function(index) {
                            var stepLen = this.stepLength || 1;
                            if (index%stepLen == 0) {
                                return true;
                            } else {
                                return false;
                            }
                        },
                        stepLength: 4,

                        initCallback: function(wrapper, data) {
                            var sc = this,
                            slist = $('.slider-top',wrapper),
                            sbottom = $('.slider-bottom',wrapper),
                            botLi = $('.slider-bar li img',wrapper);

                            var next = $('<div class="slider-next"></div>').on('click',function () {
                                sc.next.call(sc);
                            }).appendTo(wrapper);
                            var prev = $('<div class="slider-prev"></div>').on('click',function () {
                                sc.prev.call(sc);
                            }).appendTo(wrapper);

                            if (sliderParams.onInit && typeof sliderParams.onInit == 'function') {
                                sliderParams.onInit.call(this,wrapper,data);
                            }

                        },
                        // barRenderCallback: function(barItem, data, index) {
                        //     var link = $('<a href="' + data.link + '" target="_blank"></a>').appendTo(barItem);
                        //     var img = $('<img src="' + data.small_image + '" alt="' + (data.title || '') + '" />').appendTo(barItem);
                        //     var mask = $('<div>').addClass('mask').appendTo(link);

                        // },
                        renderCallback: function(wrapper, data, index) {
                            var wrapperWidth = $(wrapper).width(),
                                thisImg = $('.slider-ul img',wrapper).eq(index),
                                thisWidth = thisImg.width(),
                                thisBox = $('.slider-ul li div',wrapper).eq(index),
                                thisTitle = $('.slider-ul li p',wrapper).eq(index);
                            thisTitle.text(data.title);

                            if (sliderParams.onRender && typeof sliderParams.onRender == 'function'){
                                sliderParams.onRender.call(this,wrapper,data,index);
                            }
                        },
                        slideCallback: function(wrapper, index) {
                            var sbar = $('.slider-bar',wrapper),
                            box = $('.slider-bar li',wrapper),
                            thisBox = box.eq(index),
                            boxWidth = box.width();
                        }
                    });
                    break;
                case 'empty':
                    $.extend(sliderParams,{

                        wrapper: $(),

                        item: '',

                        barContainer: '',

                        bar: $(),

                        barItem: ''

                    });
                    break;
                default:
                break;
            }
            options = $.extend({}, sliderParams, options);
            var slider = new SliderController(options);
            slider.init();
            return slider;
        }

    };

    /*slider组件*/
    var SliderController = function(params) {
        this.params = $.extend(true, {
            mode: 'click'
        }, params);
        this._mouseIn = false;
    };
    SliderController.prototype = {
        pointer: 0,
        length: 0,
        timer: null,
        init: function() {
            var _this = this;
            var _params = this.params;
            if ($(_params.parent).find(".p-loading").length > 0) {
                this.loading = $(_params.parent).find(".p-loading");
            } else {
                this.loading = $('<div class="p-loading"></div>');
            }
            this.wrapper = $(_params.wrapper).appendTo($(_params.parent));

            this.container = this.wrapper.find("ul").eq(0);

            if (_params.fade) {
                this.container.css('transition','transform 0 ease 0');
            } else {
                this.container.css('left',0);
            }

            this.bar = $(_params.bar);
            if (_params.barContainer) {
                this.bar.appendTo(this.wrapper.find(_params.barContainer));
            } else {
                this.bar.appendTo(this.wrapper);
            }
            if (_params.data) {
                if ($(_params.parent).find(".p-loading").length == 0) {
                    this.loading.appendTo(this.wrapper);
                }
                if (typeof _params.data == "string") {
                    $.getJSON(_params.data, function(data) {
                        _this.loading.remove();
                        _this.load(data);
                    });
                } else if (typeof _params.data == "object") {
                    this.loading.remove();
                    this.load(_params.data);
                }
            }
        },
        load: function(dataList) {
            var _this = this;
            var _params = this.params;
            if (dataList) {
                for (var i in dataList) {
                    if (typeof dataList[i] != "object") continue;
                    if (_params.onData && _params.onData(dataList[i]) !== false || !_params.onData) {
                        this.add(dataList[i],i);
                    }
                }
            }
            if (_params.fade) {
                this.container.children().eq(0).css('opacity',1);
            }
            if (this.length == 0) {
                var nodata = $('<li class="no-data">没有数据</li>').appendTo(this.container);
                this.bar.hide();
            }
            $("[bar]", this.bar).eq(0).addClass("on");
            this.setTimer();

            if (browser.version.mobile || browser.version.iPad || browser.version.iPhone || browser.version.android || browser.version.windowsphone) {
                this.bindSwipeEvent(this.container);
            }

            if (_params.initCallback) {
                _params.initCallback.call(this, this.wrapper, dataList);
            }
            if (_params.onInit) {
                _params.onInit.call(this, this.wrapper, dataList);
            }
        },
        add: function(data, index, callback) {
            var _this = this;
            var _params = this.params;
            var barItem = $(_params.barItem);
            if (_params.filter) {
                var filterReturn = _params.filter(index);
                if (filterReturn) {
                    barItem.appendTo(this.bar).attr("bar", "bar").attr("index", index);
                }
            } else {
                barItem.appendTo(this.bar).attr("bar", "bar").attr("index", index);
            }

            var index = this.length;
            if (this.length == 0) {
                barItem.addClass("on");
            }
            if (_params.barRenderCallback) {
                _params.barRenderCallback.call(this, barItem, data, index);
            }
            if (_params.onBarRender) {
                _params.onBarRender.call(this, barItem, data, index);
            }
            var item;
            if (typeof _params.item == "function") {
                item = _params.item(data, index);
            } else {
                item = $(_params.item);
                if (_params.fade) {
                    item.css('opacity',0).css('transition','opacity '+ (parseInt(_params.animTime)/1000) +'s ' + _params.transFunc)
                    .css('-webkit-transition','opacity '+ (parseInt(_params.animTime)/1000) +'s ' + _params.transFunc);
                }

                $("img", item).attr("src", data.image);
                $("a", item).attr("href", data.link);
            }
            item.attr("preview", "preview").attr('index',index);

            item.appendTo(this.container);
            if (_params.renderCallback) {
                _params.renderCallback.call(this, this.wrapper, data, index, item);
            }
            if (_params.onRender) {
                _params.onRender.call(this, this.wrapper, data, index, item);
            }
            this.bindBarEvent(barItem);
            this.bindPreviewEvent(item);
            // width += 100;
            this.length++;
            // this.container.width(width + "%");
            if (typeof callback != "undefined") {
                callback(this.wrapper, data);
            }
        },
        bindSwipeEvent: function(container) {
            var _this = this,
            _params = this.params;


            var startX = 0, startY = 0; //触摸开始时手势横纵坐标
            var temPos; //滚动元素当前位置
            var timer = null;  //定时器
            var position = { x: 0, y: 0 };  //触点位置
            var oMover = container;
            var originTrans = 'transform '+ (parseInt(_params.animTime)/1000) +'s ' + _params.transFunc;

            var getEventPosition = function (e) {
                if (e.type == 'touchstart' || e.type == 'touchmove' ||
                    e.type == 'touchend' || e.type == 'touchcancel') {
                    var touches = e.changedTouches || (e.originalEvent && e. originalEvent.changedTouches), l = touches.length, touch, tagX, tagY;
                    for (var i = 0; i < l; i++) {
                        touch = touches[i];
                        tagX = touch.clientX;
                        tagY = touch.clientY;
                    }
                    position.x = tagX;
                    position.y = tagY;
                } else {
                    position.x = e.x;
                    position.y = e.y;
                }
                return position;
            };


            var touchStartFunc = function(e) {
                clearInterval(_this.timer);
                getEventPosition(e);
                startX = position.x;
                startY = position.y;
                temPos = oMover.position().left;
                oMover.css('transition','').css('-webkit-transition','');
            };
            var touchMoveFunc = function(e) {
                getEventPosition(e);
                var moveX = position.x - startX;
                var moveY = position.y - startY;
                if (Math.abs(moveY) < Math.abs(moveX) && Math.abs(moveX) < (window.screen.width || 360) / 2) {
                    e.preventDefault();
                    if (!_params.loop && _this.pointer == _this.length - 1) {
                        _this.slide(_this.pointer);
                    } else {
                        oMover.css({'transform': 'translateX(' + (temPos - 0 + moveX - 0) + 'px)'})
                        .css({'-webkit-transform': 'translateX(' + (temPos - 0 + moveX - 0) + 'px)'});
                    }

                } else {
                }
            };
            var touchEndFunc = function(e) {
                getEventPosition(e);
                var moveX = position.x - startX;
                var moveY = position.y - startY;
                if (Math.abs(moveY) < Math.abs(moveX)) {
                    if (moveX > 30) {
                        if(_this.pointer && _this.pointer > 0) {
                            _this.prev();
                        } else {
                            _this.slide(0);
                        }

                    }
                    else if (moveX <= 30 && moveX >= -30) {
                        _this.slide(_this.pointer);
                    }
                    else if (moveX < -30) {
                        _this.next();
                    }
                }
                oMover.css('transition',originTrans).css('-webkit-transition',originTrans);
            };
            var touchCancelFunc = function(e) {
                oMover.css('transition',originTrans).css('-webkit-transition',originTrans);
            };

            container.on('touchstart', touchStartFunc);
            container.on('touchmove', touchMoveFunc);
            container.on('touchend', touchEndFunc);
            container.on('touchcancel', touchCancelFunc);



        },
        // bind: function() {
        //     var _this = this;
        //     var _params = this.params;
        //     this.wrapper = $(_params.wrapper);
        //     this.container = this.wrapper.find("ul").eq(0);

        //     this.bar = null;
        //     var items = this.container.children();
        //     this.length = items.length;
        //     this.container.width(this.length * 100 + "%");
        //     this.bindPreviewEvent(items);
        //     this.setTimer();
        //     if (_params.initCallback) {
        //         _params.initCallback.call(this, this.wrapper, data);
        //     }
        // },
        bindBarEvent: function(elems) {
            var _this = this;
            if (!browser.version.mobile && !browser.version.iPad && !browser.version.iPhone && !browser.version.android && !browser.version.windowsphone) {
                // elems.hover(
                //     function() {
                //         _this._mouseIn = true;
                //         clearInterval(_this.timer);
                //         if (_this.params.mode == 'hover') {
                //             _this.slide($(this).index());
                //         }
                //     },
                //     function() {
                //         _this._mouseIn = false;
                //         _this.setTimer();
                //     }
                // );

                elems.on('mouseenter',function() {
                    _this._mouseIn = true;
                    clearInterval(_this.timer);
                    if (_this.params.mode == 'hover') {
                        _this.slide($(this).attr("index")-0);
                    }
                });
                elems.on('mouseleave',function() {
                    _this._mouseIn = false;
                    _this.setTimer();
                });
                elems.click(function() {
                    _this.slide($(this).attr("index")-0);
                });
            } else {
                elems.on('touchstart',function() {
                    _this.slide($(this).attr("index")-0);
                });
            }

        },
        barHandler: function(index) {
            var _params = this.params || {};
            if (_params.filter && typeof _params.filter == 'function') {
                var itemList = this.bar.find("[bar]"),
                stepLen = _params.stepLength;
                itemList.removeClass("on");
                itemList.each(function() {
                    var prevIndex = $(this).prev().length ? $(this).prev().attr('index') : null;
                    if(index == $(this).attr('index')) {
                        $(this).addClass("on");
                    } else {
                        if(prevIndex && index > prevIndex && index < prevIndex + stepLen) {
                            $(this).addClass("on");
                        }
                    }
                });
            } else {
                this.bar.find("[bar]").removeClass("on");
                var el = this.bar.find("[bar]").eq(index).addClass("on");
            }

        },
        bindPreviewEvent: function(elems) {
            var _this = this;
            // elems.hover(
            //     function() {
            //         clearInterval(_this.timer);
            //     },
            //     function() {
            //         _this.setTimer();
            //     }
            // );
            elems.on('mouseenter',function(){
                clearInterval(_this.timer);
            });
            elems.on('mouseleave',function(){
                _this.setTimer();
            });

        },
        slide: function(i) {
            var _this = this;
            var _params = this.params;
            if (!this._mouseIn) {
                _this.setTimer();
            }

            var unit = this.container.children().eq(i),
            unitWidth = _params.unitWidth || unit.width(),
            cleft = -i * unitWidth + 'px',
            stepLen = _params.stepLength;
            this.container.css('left',0);
            unit.addClass('on').siblings().removeClass('on');
            this.container.css('transition','transform '+ (parseInt(_params.animTime)/1000) +'s ' + _params.transFunc)
            .css('-webkit-transition','transform '+ (parseInt(_params.animTime)/1000) +'s ' + _params.transFunc);

            if (_params.fade) {
                this.container.css('transform','translateX(' + cleft + ')')
                .css('-webkit-transform','translateX(' + cleft + ')');
                this.container.children().css('opacity',0);
                this.container.children().eq(i).css('opacity',1);
            } else {
                this.container.css('transform','translateX(' + cleft + ')')
                .css('-webkit-transform','translateX(' + cleft + ')');
            }

            if(this.bar) {
                this.barHandler(i);
            }

            if(this.pointer != i && _params.slideCallback) {
                _params.slideCallback.call(this, this.wrapper, i);
            }

            if(this.pointer != i && _params.onSlide) {
                _params.onSlide.call(this, this.wrapper, i);
            }
            this.pointer = i;
        },
        setTimer: function() {
            var _this = this;
            var _params = this.params;
            clearInterval(this.timer);
            if (_params.timeout == 0 || this.length == 1) {
                return;
            }

            this.timer = setInterval(function() {
                _this.next();
            }, _params.timeout || 5000);
        },
        next: function() {
            if(this.container.hasClass('animated'))return;
            this.container.children('.clone').remove();
            var length = this.params && this.params.stepLength ? parseInt(this.params.stepLength) >> 0 : 1;
            if (this.pointer + 2*length > this.length - 1 && this.length > length) {
                if (this.pointer + length > this.length - 1 ) {
                    if (this.params.loop) {
                        this.nextLoop(0);
                    } else {

                    }

                } else {
                    this.slide(this.length - length);
                }
            } else {
                this.slide(this.pointer + length);
            }
        },
        prev: function() {
            if(this.container.hasClass('animated'))return;
            this.container.children('.clone').remove();
            var length = this.params && this.params.stepLength ? parseInt(this.params.stepLength) >> 0 : 1;
            if (this.pointer == 0 && this.length > length ) {
                if (this.params.loop) {
                    this.prevLoop(this.length - length);
                } else {

                }

            } else {
                if (this.pointer - length < 0) {
                    this.slide(0);
                } else {
                    this.slide(this.pointer - length);
                }
            }
        },
        nextLoop: function(i) {
            var _this = this;
            var _params = this.params;
            if (!this._mouseIn) {
                _this.setTimer();
            }
            var unit = this.container.children().eq(i),
            unitWidth = _params.unitWidth || unit.width(),
            stepLen = _params.stepLength;
            unit.addClass('on').siblings().removeClass('on');

            for (var j=0;j<stepLen;j++) {
                var item = this.container.children().eq(j);
                item.clone().addClass('clone').appendTo(this.container);
            }

            this.container.css('transition','transform '+ (parseInt(_params.animTime)/1000) +'s ' + _params.transFunc)
            .css('-webkit-transition','transform '+ (parseInt(_params.animTime)/1000) +'s ' + _params.transFunc);
            this.container.css('transform','translateX(-' + this.length*unitWidth + 'px)')
            .css('-webkit-transform','translateX(-' + this.length*unitWidth + 'px)')
            .addClass('animated');

            window.sliderLoopResetNext = function() {
                _this.container.css('-webkit-transition','').css('transition','').css('transform','').css('left',0).removeClass('animated');
            };
            setTimeout('sliderLoopResetNext()',_params.animTime);

            if(this.bar) {
                this.barHandler(i);
            }

            if(this.pointer != i && _params.slideCallback) {
                _params.slideCallback.call(this, this.wrapper, i);
            }
            if(this.pointer != i && _params.onSlide) {
                _params.onSlide.call(this, this.wrapper, i);
            }
            this.pointer = i;
        },
        prevLoop: function(i) {
            var _this = this;
            var _params = this.params;
            if (!this._mouseIn) {
                _this.setTimer();
            }
            var unit = this.container.children().eq(i),
            unitWidth = _params.unitWidth || unit.width(),
            stepLen = _params.stepLength,
            lastPage = this.length > stepLen ? this.length - stepLen : 0;

            unit.addClass('on').siblings().removeClass('on');
            this.container.css('transition','transform '+ (parseInt(_params.animTime)/1000) +'s ' + _params.transFunc)
            .css('-webkit-transition','transform '+ (parseInt(_params.animTime)/1000) +'s ' + _params.transFunc);

            for (var j = 0; j < stepLen; j++) {
                var k = this.length - 1 , item = this.container.children().eq(k);
                item.clone().addClass('clone').prependTo(this.container);
            }

            this.container.css('left','-' + stepLen*unitWidth + 'px')
            .css('transform','translateX(' + stepLen*unitWidth + 'px)')
            .css('-webkit-transform','translateX(' + stepLen*unitWidth + 'px)')
            .addClass('animated');

            window.sliderLoopResetPrev = function() {
                _this.container.css('transition','')
                .css('-webkit-transition','')
                .css('transform','translateX(-' + (lastPage) * unitWidth + 'px)')
                .css('-webkit-transform','translateX(-' + (lastPage) * unitWidth + 'px)')
                .css('left',0).removeClass('animated');;
                _this.container.children('.clone').remove();
            };
            setTimeout('sliderLoopResetPrev()',_params.animTime);

            if(this.bar) {
                this.barHandler(i);
            }

            if(this.pointer != i && _params.slideCallback) {
                _params.slideCallback.call(this, this.wrapper, i);
            }
            if(this.pointer != i && _params.onSlide) {
                _params.onSlide.call(this, this.wrapper, i);
            }
            this.pointer = i;
        },
        destroy: function() {
            clearInterval(this.timer);
            this.wrapper.remove();
        }
    };

    $.fn.biliSlider = function(method) {
        if (!method) {
            $.error('BiliPager needs an argument.');
        } else if (typeof method === 'object') {
            return methods.init.apply(this, arguments);
        }
    };

})(window.jQuery || window.Zepto);


/** WEBPACK FOOTER **
 ** ./src/js/plugins/biliSlider.js
 **/